import { ReactNode } from 'react';
import styled from 'styled-components';
import { breakpoints } from '@upright/ui/common/generic/global/breakpoints';

interface ProductFooterProps {
  productCount?: number;
  children: ReactNode;
}

export function ProductFooter({ productCount, children }: ProductFooterProps) {
  return (
    <BottomArea>
      <ProductCount>
        {productCount !== undefined && productCount > 0 ? (
          <>
            A total of <b>{productCount}</b> product(s)
          </>
        ) : null}
      </ProductCount>
      <BottomAreaRight>{children}</BottomAreaRight>
    </BottomArea>
  );
}

const BottomArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--space__lg);

  @media (max-width: ${breakpoints[0]}) {
    flex-direction: column;
    align-items: stretch;
    gap: var(--space__lg);
  }
`;

const ProductCount = styled.div`
  font-size: var(--font-size__md);
  color: var(--platform-gray-500);
  line-height: 1;

  @media (max-width: ${breakpoints[0]}) {
    text-align: left;
    order: 2;
  }
`;

const BottomAreaRight = styled.div`
  flex-grow: 0;
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: var(--space__lg);

  @media (max-width: ${breakpoints[0]}) {
    align-self: stretch;
    justify-content: center;
    order: 1;
    flex-direction: column;
    gap: var(--space__sm);
  }
`;
